var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAddMedia = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 25,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M13.46 1.757a1 1 0 1 1 0 2H8.04a5 5 0 0 0-5 5v4.391l1.472-1.5a2.635 2.635 0 0 1 3.726 0l3.855 3.855 1.203-1.21a2.636 2.636 0 0 1 3.727 0l3.166 3.11c.114-.42.177-.863.177-1.32v-5.42a1 1 0 0 1 2 0v5.42a7 7 0 0 1-7 7H8.04a7 7 0 0 1-7-7V8.757a7 7 0 0 1 7-7h5.42Zm2.321 13.778a.878.878 0 0 0-1.242 0l-5.505 5.548h6.332c1.641 0 3.097-.79 4.009-2.012l-3.594-3.536Zm-8.785-2.644a.878.878 0 0 0-1.242 0L3.04 15.654v.429a5 5 0 0 0 3.687 4.824l4.128-4.157-3.859-3.86Zm5.519-5.742a1.757 1.757 0 1 1 0 3.514 1.757 1.757 0 0 1 0-3.514Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  d: "M20.04 1v6M23.04 4h-6"
})));
export default SvgAddMedia;